// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.News_container__lCNDU {
  display: grid;
  grid-template-columns: 3fr 1fr;
  gap: 2rem;
}
@media only screen and (max-width: 43.75em) {
  .News_container__lCNDU {
    grid-template-columns: 1fr;
  }
}
.News_container_top__hWuEG {
  width: 100%;
  box-sizing: border-box;
  padding: 2rem;
  box-shadow: 0px 0px 7px rgba(34, 103, 206, 0.5);
  gap: 2rem;
}
.News_container_top__item__ETav9 {
  display: flex;
  justify-content: space-between;
  padding-bottom: 2rem;
  gap: 2rem;
}
.News_container_bottom__dKcRw {
  width: 100%;
  box-sizing: border-box;
  padding: 2rem 4rem;
  box-shadow: 0px 0px 7px rgba(34, 103, 206, 0.5);
}

.News_imgContainer__O9krG {
  display: flex;
  flex-wrap: wrap;
}
.News_imgContainer_card__v0zJ2 {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  padding: 2rem;
  box-shadow: 0px 0px 7px rgba(34, 103, 206, 0.5);
  gap: 1rem;
}
.News_imgContainer_img__FfO7P {
  height: 20rem;
  width: 30rem;
  padding-bottom: 2rem;
}

.News_switch__U57q\\+ {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  box-sizing: border-box;
  font-size: var(--default-font-small);
  width: fit-content;
  margin-top: 4rem;
  margin-bottom: 1rem;
  cursor: pointer;
}
.News_switch__U57q\\+ > * {
  padding: 1rem 1rem;
  text-align: center;
}
.News_switch__show__zNdQK {
  background-color: var(--color-dark);
  color: var(--color-white);
  transition: all 0.4s;
}
.News_switch__show_b__IXJxL {
  border: 1px solid var(--color-dark);
  transition: all 0.4s;
}
.News_switch__hide__x-n\\+9 {
  background-color: var(--color-dark);
  color: var(--color-white);
  transition: all 0.4s;
}
.News_switch__hide_b__NDdsx {
  border: 1px solid var(--color-dark);
  transition: all 0.4s;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/News/News.module.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AADF;AAGE;EALF;IAMI,0BAAA;EAAF;AACF;AACE;EACE,WAAA;EACA,sBAAA;EACA,aAAA;EACA,+CAAA;EACA,SAAA;AACJ;AACI;EACE,aAAA;EACA,8BAAA;EACA,oBAAA;EACA,SAAA;AACN;AAGE;EACE,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,+CAAA;AADJ;;AAIA;EACE,aAAA;EACA,eAAA;AADF;AAEE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,aAAA;EACA,+CAAA;EACA,SAAA;AAAJ;AAEE;EACE,aAAA;EACA,YAAA;EACA,oBAAA;AAAJ;;AAIA;EACE,aAAA;EACA,kCAAA;EACA,sBAAA;EACA,oCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AADF;AAGE;EACE,kBAAA;EACA,kBAAA;AADJ;AAIE;EACE,mCAAA;EACA,yBAAA;EAEA,oBAAA;AAHJ;AAKI;EACE,mCAAA;EAEA,oBAAA;AAJN;AAQE;EACE,mCAAA;EACA,yBAAA;EAEA,oBAAA;AAPJ;AASI;EACE,mCAAA;EAEA,oBAAA;AARN","sourcesContent":["@import \"../variables/breakpoints\";\n\n.container {\n  display: grid;\n  grid-template-columns: 3fr 1fr;\n  gap: 2rem;\n\n  @media only screen and (max-width: $bp-700) {\n    grid-template-columns: 1fr;\n  }\n  &_top {\n    width: 100%;\n    box-sizing: border-box;\n    padding: 2rem;\n    box-shadow: 0px 0px 7px rgba(34, 103, 206, 0.5);\n    gap: 2rem;\n\n    &__item {\n      display: flex;\n      justify-content: space-between;\n      padding-bottom: 2rem;\n      gap: 2rem;\n    }\n  }\n\n  &_bottom {\n    width: 100%;\n    box-sizing: border-box;\n    padding: 2rem 4rem;\n    box-shadow: 0px 0px 7px rgba(34, 103, 206, 0.5);\n  }\n}\n.imgContainer {\n  display: flex;\n  flex-wrap: wrap;\n  &_card {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    box-sizing: border-box;\n    padding: 2rem;\n    box-shadow: 0px 0px 7px rgba(34, 103, 206, 0.5);\n    gap: 1rem;\n  }\n  &_img {\n    height: 20rem;\n    width: 30rem;\n    padding-bottom: 2rem;\n  }\n}\n\n.switch {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  box-sizing: border-box;\n  font-size: var(--default-font-small);\n  width: fit-content;\n  margin-top: 4rem;\n  margin-bottom: 1rem;\n  cursor: pointer;\n\n  & > * {\n    padding: 1rem 1rem;\n    text-align: center;\n  }\n\n  &__show {\n    background-color: var(--color-dark);\n    color: var(--color-white);\n    // border-radius: 1rem 0 0 1rem;\n    transition: all 0.4s;\n\n    &_b {\n      border: 1px solid var(--color-dark);\n      // border-radius: 1rem 0 0 1rem;\n      transition: all 0.4s;\n    }\n  }\n\n  &__hide {\n    background-color: var(--color-dark);\n    color: var(--color-white);\n    // border-radius: 0 1rem 1rem 0;\n    transition: all 0.4s;\n\n    &_b {\n      border: 1px solid var(--color-dark);\n      // border-radius: 0 1rem 1rem 0;\n      transition: all 0.4s;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `News_container__lCNDU`,
	"container_top": `News_container_top__hWuEG`,
	"container_top__item": `News_container_top__item__ETav9`,
	"container_bottom": `News_container_bottom__dKcRw`,
	"imgContainer": `News_imgContainer__O9krG`,
	"imgContainer_card": `News_imgContainer_card__v0zJ2`,
	"imgContainer_img": `News_imgContainer_img__FfO7P`,
	"switch": `News_switch__U57q+`,
	"switch__show": `News_switch__show__zNdQK`,
	"switch__show_b": `News_switch__show_b__IXJxL`,
	"switch__hide": `News_switch__hide__x-n+9`,
	"switch__hide_b": `News_switch__hide_b__NDdsx`
};
export default ___CSS_LOADER_EXPORT___;
